import React, { useState } from 'react';
import { useI18n } from 'react-simple-i18n';
import line1 from '../assets/img/lines/1-svg.svg';
import appstate, { getLocaledString } from '../appstate';
import tw2 from '../assets/img/tw2.jpg';

export default function KeyOrgsView() {
	const { t } = useI18n();

	const getOrgByName = (name: string) => {
		return appstate.orgs().find((org) => {
			return org.name === name;
		});
	};

	const [activeOrg, setActiveOrg] = React.useState('');
	const [slideOut, setSlideOut] = useState(false);

	return (
		<div>
			<div
				className={
					'w-full cloud-bg text-primary-500 h-124 rounded-t shadow border overflow-hidden p-8 flex flex-col justify-center items-center gap-8 relative'
				}
			>
				<div className={'max-h-full overflow-auto'}>
					<div
						className={
							'absolute w-full h-full top-0 left-0 z-0 opacity-15 blur-sm'
						}
						style={{
							backgroundImage: `url(${tw2})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
						}}
					/>
					{activeOrg ? (
						<div
							className={`flex flex-col justify-center items-center transform transition ${
								slideOut
									? '-translate-x-40 opacity-0'
									: 'translate-x-0 opacity-100'
							}`}
						>
							<div className={'bg-white rounded shadow p-4'}>
								<img
									src={getOrgByName(activeOrg)?.logo}
									className={'h-16'}
								/>
							</div>
							<div
								className={'text-xl font-bold text-center mt-8'}
							>
								{getOrgByName(activeOrg)?.name}
							</div>
							<div
								className={
									'text-lg text-center px-60 mt-8 flex flex-col gap-2 text-bčacl'
								}
							>
								{getOrgByName(activeOrg)
									?.description.split('\n')
									.map((line, index) => {
										if (line.includes('Telefon:')) {
											return (
												<a
													key={index}
													className={'underline'}
													href={`tel:${
														line.split(':')[1]
													}`}
												>
													{line.split(':')[1]}
												</a>
											);
										}
										if (line.includes('E-pošta:')) {
											return (
												<a
													key={index}
													className={'underline'}
													href={`mailto:${
														line.split(':')[1]
													}`}
												>
													{line.split(':')[1]}
												</a>
											);
										}
										if (line.includes('Spletna stran:')) {
											return (
												<a
													key={index}
													className={'underline'}
													href={`${
														line.split(
															'Spletna stran:',
														)[1]
													}`}
												>
													{
														line.split(
															'Spletna stran:',
														)[1]
													}
												</a>
											);
										}
										if (
											line ===
											'ZSSS redno izvaja terenske aktivnosti in kreira poročila, glede aktualnih razmer v družbi. Na svoji spletni strani objavlja izvlečke poročil, ki prispevajo k ozaveščanju o pomembnosti usklajevanja poklicnega in zasebnega življenja. Več o vsebinah je dostopno tukaj: ABCDEFGH'
										) {
											return (
												<div key={line}>
													ZSSS redno izvaja terenske
													aktivnosti in kreira
													poročila, glede aktualnih
													razmer v družbi. Na svoji
													spletni strani objavlja
													izvlečke poročil, ki
													prispevajo k ozaveščanju o
													pomembnosti usklajevanja
													poklicnega in zasebnega
													življenja. Več o vsebinah je
													dostopno tukaj:{' '}
													<a
														className={'underline'}
														target={'_blank'}
														href="https://www.zsss.si/podrocja-dela/enake-moznosti/enakost-spolov/"
														rel="noreferrer"
													>
														https://www.zsss.si/podrocja-dela/enake-moznosti/enakost-spolov/
													</a>
												</div>
											);
										}
										return <div key={index}>{line}</div>;
									})}
							</div>
						</div>
					) : (
						<div
							className={`transform transition ${
								slideOut
									? '-translate-x-24 opacity-0'
									: 'translate-x-0 opacity-100'
							}`}
						>
							<div
								className={
									'text-3xl font-bold text-center mb-4 text-primary-500'
								}
							>
								{getLocaledString(
									'Ključne organizacije',
									'Key organizations',
								)}
							</div>
							<div className={'text-xl text-primary-500'}>
								{getLocaledString(
									'Pritiskaj na spodnje ikone (logotipe) in spoznaj več o organizaciji',
									'Press the icons below and get acquainted with different organizations',
								)}
							</div>
						</div>
					)}
				</div>
			</div>
			<div
				className={
					'flex flex-row flex-wrap gap-8 py-10 justify-center items-center bg-white rounded-b shadow '
				}
			>
				{appstate.orgs().map((org, index) => {
					return (
						<div
							key={index}
							className={
								'flex justify-center items-center cursor-pointer transform hover:scale-105 transition'
							}
							onClick={() => {
								if (org.name !== activeOrg) {
									setSlideOut(true);
									setTimeout(() => {
										setActiveOrg(org.name);
										requestAnimationFrame(() => {
											setSlideOut(false);
										});
									}, 150);
								}
							}}
						>
							<img
								src={org.logo}
								alt={org.name}
								className={'w-16 md:w-28 h-auto'}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
}
